import { Button } from "react-bootstrap";
import { useHrStyles } from "../../Context/HRContext";
import "./CivilText.css";

export default function CivilText() {
  const hrStyles = useHrStyles();
  return (
    <div className="Struct-text-container">
      <p
        style={{
          textAlign: "justify",
          fontSize: "1em",
          paddingLeft: "1em",
          paddingRight: "1em",
          fontFamily: "'Inria Serif', serif",
          padding: "0% 20%",
          paddingTop: "2em",
        }}
      >
        BEAMS provides comprehensive civil engineering services that lay the
        groundwork for successful and sustainable infrastructure projects. Our
        expertise spans across transportation, water management, and urban
        planning, ensuring that every project we undertake enhances
        functionality and sustainability. From the selection of materials to the
        planning and execution phases, our team ensures that civil
        infrastructure projects are built to be efficient, resilient, and
        environmentally responsible. By incorporating the latest engineering
        technologies and best practices, we help create infrastructure that
        supports thriving communities and businesses for years to come.
      </p>
      <Button
        href="/Contact"
        variant="outline-danger"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
      <div style={{ marginTop: "20px" }}></div>
    </div>
  );
}
